import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=2323ba96"
import script from "./CommentDialog.vue?vue&type=script&lang=js"
export * from "./CommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports